import { Navigate, useRoutes } from "react-router-dom";
import SimpleLayout from "./layouts/simple";
import PosPage from "./pages/PosPage";
import Menu from "./pages/Selling/Menu";
import Tables from "./pages/Tables";
import Widgets from "./pages/Widgets";
import Items from "./pages/Items";
import { useContext } from "react";
import { AppContext } from "./AppContext";
import OrderTabs from "./pages/Tables/OrderTabs";
import ProductionCenter from "./pages/ProductionCenter/ProductionCenter";
import KitchenDashboard from "./pages/KitchenDashboard";
import KdsStationsPage from "./pages/KdsStations";
import KdsTabs from "./pages/KdsTabs";
import Kiosk from "./pages/Kiosk";
import KioskPreview from "./pages/KioskPreview";
import { getSpecialRoleLandingPath, SPECIAL_ROLE_PROFILES } from "./frappeConfig";
import RestaurantOnlineOrdersPage from "./restaurantStorefront/staff/RestaurantOnlineOrdersPage";

// ----------------------------------------------------------------------

export default function Router() {
    const {
        isTabsPos,
        isKitchenUser,
        isRetailPos,
        restaurantSettings,
        restaurantSettingsStatus,
        userInfo,
    } = useContext(AppContext);
    const roleProfileName = userInfo?.role_profile_name;
    const specialRoleLandingPath = getSpecialRoleLandingPath(roleProfileName);
    const kdsRoleProfile =
        restaurantSettings?.docs?.[0]?.kds_production_center?.trim?.();
    const kitchenRedirectTarget = kdsRoleProfile
        ? `/kds/${encodeURIComponent(kdsRoleProfile)}`
        : "/kds";
    const kitchenRoutes =
        restaurantSettingsStatus === "loading"
            ? [
                  {
                      path: "*",
                      element: null,
                  },
              ]
            : [
                  {
                      path: "/kds",
                      element: <KitchenDashboard />,
                  },
                  {
                      path: "/kds/:productionCenter",
                      element: <KitchenDashboard />,
                  },
                  {
                      path: "/kds-stations",
                      element: <KdsStationsPage />,
                  },
                  {
                      path: "/kds-stations/:stationName",
                      element: <KdsStationsPage />,
                  },
                  {
                      path: "/kds-stations/:stationName/:substation",
                      element: <KdsStationsPage />,
                  },
                  {
                      path: "*",
                      element: <Navigate to={kitchenRedirectTarget} replace />,
                  },
              ];

    const routes = useRoutes(
        roleProfileName === SPECIAL_ROLE_PROFILES.KDS_TABS
            ? [
                  { path: "/kds-tabs", element: <KdsTabs /> },
                  {
                      path: "*",
                      element: <Navigate to={specialRoleLandingPath} replace />,
                  },
              ]
            : roleProfileName === SPECIAL_ROLE_PROFILES.KIOSK_PREVIEW
            ? [
                  { path: "/kiosk-preview", element: <KioskPreview /> },
                  {
                      path: "*",
                      element: <Navigate to={specialRoleLandingPath} replace />,
                  },
              ]
            : roleProfileName === SPECIAL_ROLE_PROFILES.KIOSK
            ? [
                  { path: "/kiosk", element: <Kiosk /> },
                  {
                      path: "/kiosk/:tableName",
                      element: <Kiosk />,
                  },
                  {
                      path: "*",
                      element: <Navigate to={specialRoleLandingPath} replace />,
                  },
              ]
            : isKitchenUser
            ? kitchenRoutes
            : [
        {
            path: "/tables",
            element: isRetailPos ? (
                <Navigate to="/pos" replace />
            ) : isTabsPos ? (
                <OrderTabs />
            ) : (
                <Tables />
            ),
        },
        {
            path: "/pos",
            element: <PosPage />,
        },
        {
            path: "/pos/:tableName/:orderName?",
            element: isRetailPos ? <Navigate to="/pos" replace /> : <PosPage />,
        },
        {
            path: "/items",
            element: <Items />,
        },
        {
            path: "/restaurant-orders",
            element: isRetailPos ? <Navigate to="/pos" replace /> : <RestaurantOnlineOrdersPage />,
        },
        {
            path: "/production-center",
            element: <ProductionCenter />,
        },
        {
            path: "/kds",
            element: <KitchenDashboard />,
        },
        {
            path: "/kds/:productionCenter",
            element: <KitchenDashboard />,
        },
        {
            path: "/kds-stations",
            element: <KdsStationsPage />,
        },
        {
            path: "/kds-stations/:stationName",
            element: <KdsStationsPage />,
        },
        {
            path: "/kds-stations/:stationName/:substation",
            element: <KdsStationsPage />,
        },
        {
            path: "/dashboard",
            children: [
                { element: <Navigate to="/dashboard/selling" />, index: true },
                { path: "menu", element: <Menu /> },
                { path: "widgets", element: <Widgets /> },
            ],
        },
        {
            element: <SimpleLayout />,
            children: [
                { element: <Navigate to={isRetailPos ? "/pos" : "/tables"} />, index: true },
                { path: "404", element: <Tables /> },
            ],
        },
              ]
    );

    return routes;
}
